import timelineEvent from '~/mixins/timeline-event';

export default {
  mixins: [timelineEvent],
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/timeline/events/creative-preview/CreativePreview.js